/* Auto-extracted from LanguageContext.tsx. One locale per file.
   Keep keys in sync across en/tr. */
export const en: Record<string, string> = {
    // --- Redesign additions ---
    'nav.manage': 'Manage',
    'nav.account': 'Account',
    'notifications.title': 'Notifications',
    'notifications.markAllRead': 'Mark all read',
    'notifications.empty': 'No notifications yet',
    'auth.register.companySection': 'Company',
    'auth.register.accountSection': 'Account',
    'auth.register.strengthWeak': 'Weak password',
    'auth.register.strengthFair': 'Fair password',
    'auth.register.strengthGood': 'Good password',
    'auth.register.strengthStrong': 'Strong password',
    'dashboard.resetLayout': 'Reset layout',
    'dashboard.actions.unreplied': 'Unreplied reviews',
    'dashboard.actions.recentNegative': 'Negative reviews this week',
    'dashboard.actions.allClear': 'All caught up',
    'dashboard.actions.allClearDesc': 'No pending items need your attention.',
    'review.clearFilters': 'Clear filters',
    'review.recommended': 'Recommended',
    'footer.privacy': 'Privacy Policy',
    'footer.terms': 'Terms of Service',
    'footer.cookies': 'Cookie Policy',
    'landing.preview.businesses': 'Businesses',
    'subscription.statusInactive': 'Inactive',
    'subscription.statusPending': 'Pending',
    'agency.searchClients': 'Search clients...',
    'agency.noClientsDescription': 'When you add clients to your agency, they will appear here.',
    'agency.noClientsMatch': 'No matching clients',
    'agency.noClientsMatchDescription': 'Try adjusting your search terms.',
    'apiKeys.newKeyTitle': 'Your new API key',
    'apiKeys.keyConfirm': "I've copied my key",
    'apiKeys.copyWarningDetail': "For security, this key won't be shown again. Store it somewhere safe.",
    'common.copied': 'Copied',
    'auth.hero.tag1': '4.8★',
    'auth.hero.tag2': '1,200+ reviews/day',
    'auth.hero.tag3': 'AI-powered',
    'auth.hero.title': 'Understand your Google reviews in 60 seconds',
    'auth.hero.description': "Turkey's leading restaurant and hotel chains manage their reputation with Revomira.",
    'auth.hero.period': 'Last 30 days',
    'auth.hero.growth': '↑ +12.3%',
    'auth.hero.statReviews': 'Total Reviews',
    'auth.hero.statRating': 'Avg. Rating',
    'auth.hero.statResponse': 'Response Rate',
    'auth.hero.footer': '© 2026 Revomira. Made in Türkiye.',
    'auth.hero.backHome': '← Back to home',

    // Page Title
    'page.title': 'Revomira - See beyond reviews',
    
    // Navigation
    'nav.home': 'Home',
    'nav.signIn': 'Sign In',
    'nav.getStarted': 'Get Started',
    'nav.about': 'About',
    'nav.contact': 'Contact',
    'nav.openMenu': 'Open menu',
    'nav.closeMenu': 'Close menu',
    
    // Hero
    'hero.badge': '🚀 Built for Turkish growth teams',
    'hero.title': 'Understand your Google reviews in 60 seconds',
    'hero.titleHighlight': 'reviews',
    'hero.subtitle': 'Manage all your business reviews in one place, analyze with AI, and send direct replies.',
    'hero.subcopy': 'For restaurants, hotels, and retail chains in Turkey',
    'hero.cta.start': 'Start Free — No credit card required',
    'hero.cta.demo': 'Watch Demo',
    
    // Features
    'features.title': 'Everything you need to manage your reputation',
    'features.subtitle': 'Powerful features designed for modern businesses',
    'features.ai.title': 'AI-Powered Insights',
    'features.ai.desc': 'Get intelligent analysis of your reviews with sentiment analysis and actionable insights.',
    'features.platform.title': 'Multi-Platform Integration',
    'features.platform.desc': 'Connect Google My Business now, with TripAdvisor, Booking.com and more coming soon.',
    'features.analytics.title': 'Advanced Analytics',
    'features.analytics.desc': 'Comprehensive reporting and analytics to track your reputation across all platforms.',
    'features.security.title': 'Enterprise Security',
    'features.security.desc': 'Bank-level security with role-based access control and data encryption.',
    'features.realtime.title': 'Real-time Monitoring',
    'features.realtime.desc': 'Get instant notifications when new reviews are posted across all platforms.',
    'features.team.title': 'Team Collaboration',
    'features.team.desc': 'Manage multiple users with different permission levels for your organization.',
    
    // Pricing
    'pricing.title': 'Simple, transparent pricing',
    'pricing.subtitle': 'Choose the plan that\'s right for your business',
    'pricing.monthly': 'Monthly',
    'pricing.yearly': 'Yearly',
    'pricing.save': 'Save 20%',
    'pricing.basic.name': 'Basic',
    'pricing.basic.desc': 'Perfect for small businesses',
    'pricing.professional.name': 'Professional',
    'pricing.professional.desc': 'For growing businesses',
    'pricing.enterprise.name': 'Enterprise',
    'pricing.enterprise.desc': 'For agencies and multi-location businesses',
    'pricing.mostPopular': 'Most Popular',
    'pricing.getStarted': 'Get Started',
    'pricing.month': 'month',
    'pricing.year': 'year',
    'pricing.basic.feature1': 'Up to 5 businesses',
    'pricing.basic.feature2': 'Google My Business integration',
    'pricing.basic.feature3': 'Basic analytics',
    'pricing.basic.feature4': 'Email support',
    'pricing.basic.feature5': '1 user account',
    'pricing.professional.feature1': 'Up to 25 businesses',
    'pricing.professional.feature2': 'All platform integrations',
    'pricing.professional.feature3': 'Advanced analytics & AI insights',
    'pricing.professional.feature4': 'Priority support',
    'pricing.professional.feature5': 'Up to 10 user accounts',
    'pricing.professional.feature6': 'Custom reporting',
    'pricing.enterprise.feature1': 'Unlimited businesses',
    'pricing.enterprise.feature2': 'All platform integrations',
    'pricing.enterprise.feature3': 'Advanced AI & machine learning',
    'pricing.enterprise.feature5': 'Unlimited user accounts',
    'pricing.enterprise.feature6': 'API access',

    // Testimonials
    'testimonials.title': 'Trusted by businesses worldwide',
    'testimonials.subtitle': 'See what our customers are saying',
    
    // CTA
    'cta.title': 'Ready to transform your reputation management?',
    'cta.subtitle': 'Join thousands of businesses already using Revomira to manage their online reputation.',
    'cta.start': 'Start Free Trial',
    'cta.contact': 'Contact Sales',

    // Onboarding
    'onboarding.modalTitle': 'Welcome',
    'onboarding.welcome.title': "Welcome to Revomira",
    'onboarding.welcome.subtitle': 'Your 14-day trial has started. Let\'s complete the first setup.',
    'onboarding.welcome.cta': 'Let\'s Start',
    'onboarding.connect.title': 'Connect your Google Business Profile',
    'onboarding.connect.subtitle': 'Connect a business to fetch your reviews automatically.',
    'onboarding.connect.connectButton': 'Connect Platform',
    'onboarding.connect.skipButton': 'Not Now',
    'onboarding.ready.title': 'You are ready',
    'onboarding.ready.completing': 'Completing...',
    'onboarding.ready.syncing': 'Syncing...',
    'onboarding.ready.goToDashboard': 'Go to Dashboard',
    'onboarding.sync.ready': 'Ready to start your first synchronization.',
    'onboarding.sync.checkingConnections': 'Checking connected platforms...',
    'onboarding.sync.businessNotFound': 'Business not found. You can add your first business from the dashboard.',
    'onboarding.sync.noPlatformConnected': 'No platform connected yet. You can connect one from the Businesses page.',
    'onboarding.sync.fetchingReviews': 'Fetching first reviews...',
    'onboarding.sync.completed': 'Initial synchronization completed.',
    'onboarding.sync.failed': 'Initial synchronization could not be started for now. You can retry from the dashboard.',
    
    // Footer
    'footer.description': 'AI-powered review management platform for modern businesses.',
    'footer.copyright': '© 2025 Revomira. All rights reserved.',
    
    // SEO
    'seo.login.title': 'Sign In | Revomira',
    'seo.register.title': 'Register | Revomira',
    'seo.privacy.title': 'Privacy Policy | Revomira',
    'seo.privacy.description': 'Revomira privacy policy and personal data processing practices.',
    'seo.terms.title': 'Terms of Service | Revomira',
    'seo.terms.description': 'Terms and conditions for using the Revomira platform.',
    'seo.contact.title': 'Contact | Revomira',
    'seo.about.title': 'About | Revomira',
    'seo.forgotPassword.title': 'Forgot Password | Revomira',
    'seo.setupPassword.title': 'Set Up Password | Revomira',
    'seo.cookie.title': 'Cookie Policy | Revomira',
    'seo.cookie.description': 'How Revomira uses cookies and similar technologies.',

    // Auth
    'auth.login.title': 'Sign in',
    'auth.login.subtitle': 'Enter your credentials to continue',
    'auth.login.email': 'Email',
    'auth.login.emailPlaceholder': 'Enter your email',
    'auth.login.password': 'Password',
    'auth.login.passwordPlaceholder': 'Enter your password',
    'auth.login.remember': 'Remember me',
    'auth.login.forgotPassword': 'Forgot password?',
    'auth.login.signIn': 'Sign in',
    'auth.login.signingIn': 'Signing in...',
    'auth.login.noAccount': 'Don\'t have an account?',
    'auth.login.requestAccess': 'Request access',
    'auth.login.welcomeBack': 'Welcome back!',
    'auth.login.success': 'You have successfully logged in.',
    'auth.login.failed': 'Login failed',
    'auth.login.invalid': 'Invalid email or password',
    'auth.login.userNotFound': 'User not found',
    'auth.login.accountPending': 'Account is pending approval. Please set your password via the setup link first.',
    'auth.login.accountInactive': 'User account is not active',
    'auth.login.mustSetPassword': 'You must set your password first via the setup link',
    'auth.login.organizationNotFound': 'Organization not found',
    
    'auth.register.title': 'Create Account',
    'auth.register.subtitle': 'Register your organization',
    'auth.register.companyName': 'Company Name',
    'auth.register.companyNamePlaceholder': 'Enter your company name',
    'auth.register.contactName': 'Contact Name',
    'auth.register.contactNamePlaceholder': 'Enter your full name',
    'auth.register.contactEmail': 'Contact Email',
    'auth.register.contactEmailPlaceholder': 'Enter your email address',
    'auth.register.phoneNumber': 'Phone Number (Optional)',
    'auth.register.phoneNumberPlaceholder': 'Enter your phone number',
    'auth.register.submit': 'Submit Request',
    'auth.register.submitting': 'Submitting request...',
    'auth.register.submitted': 'Registration request submitted!',
    'auth.register.submittedDesc': 'We\'ll review your request and get back to you within 24 hours.',
    'auth.register.alreadyHave': 'Already have an account?',
    'auth.register.signIn': 'Sign in',
    'auth.register.backToSignIn': 'Back to Sign In',
    'auth.register.whatNext': 'What happens next?',
    'auth.register.review': 'Our team will review your application',
    'auth.register.email': 'You\'ll receive an email with approval status',
    'auth.register.approved': 'If approved, you\'ll get setup instructions',
    'auth.register.start': 'Start managing your reviews immediately',
    'auth.register.whatExpect': 'What to expect:',
    'auth.register.quickApproval': 'Quick approval process (usually within 24 hours)',
    'auth.register.freeTrial': 'Free trial with full access to all features',
    'auth.register.support': 'Dedicated onboarding support',
    'auth.register.noCreditCard': 'No credit card required for trial',
    'auth.register.failed': 'Registration failed',
    'auth.register.tryAgain': 'Please try again later',
    'auth.register.alreadyExists': 'This email or company is already registered',
    'auth.register.acceptTerms': 'I accept the',
    'auth.register.privacyPolicy': 'Privacy Policy',
    'auth.register.termsOfService': 'Terms of Service',
    'auth.register.cookiePolicy': 'Cookie Policy',
    'auth.register.termsRequired': 'You must accept the Privacy Policy and Cookie Policy to continue',
    'auth.register.kvkkRequired': 'KVKK explicit consent is required.',
    'auth.register.kvkkConsentLabel': "I have read the KVKK Disclosure Text and consent to the processing of my personal data.",
    'auth.register.kvkkViewButton': 'View KVKK Text',
    'auth.register.successAccountCreated': 'Your account was created',
    'auth.register.successSignIn': 'You can sign in with your email and password',
    'auth.register.successOnboarding': 'Complete initial setup with the onboarding steps',
    'auth.register.successStartAnalysis': 'Start your first review analysis right away',
    'auth.register.afterRegisterSignIn': 'You can sign in immediately after registration',

    'dashboard.trial.daysRemaining': '{days} days left in your trial',
    'dashboard.trial.active': 'Your trial is active',
    'dashboard.trial.upgrade': 'Upgrade Plan',
    'dashboard.customLayout': 'Customizable dashboard layout',
    'dashboard.dragHint': 'Use the drag handle on each card to reorder widgets. Focus the handle and use arrow keys to move items.',
    'dashboard.dragHandle': 'Drag to reorder widget',
    'dashboard.empty.title': 'Add your first business to get started',
    'dashboard.empty.description': 'Connect your Google Business Profile to sync reviews and unlock analytics.',
    'dashboard.empty.cta': 'Add a Business',
    'dashboard.charts.orgScopeHint': 'Charts include all businesses; advanced analytics are per selected business.',

    'apiKeys.title': 'API Keys',
    'apiKeys.labelPlaceholder': 'Key label (e.g. Production)',
    'apiKeys.create': 'Create key',
    'apiKeys.copyWarning': 'Copy this key now — it will not be shown again.',
    'apiKeys.revoke': 'Revoke',
    'apiKeys.revokeConfirm': 'Are you sure you want to revoke this key?',
    'apiKeys.empty': 'No API keys yet.',
    'apiKeys.lastUsed': 'Last used',
    'apiKeys.never': 'Never',
    'apiKeys.scopeReviews': 'Reviews (read)',
    'apiKeys.scopeAnalytics': 'Analytics (read)',
    'apiKeys.active': 'Active',
    'apiKeys.revoked': 'Revoked',
    'apiKeys.created': 'Created',

    'agency.title': 'Agency',
    'agency.clients': 'Agency Clients',
    'agency.rating': 'Avg. rating (30d)',
    'agency.unresponded': 'Unresponded reviews',
    'agency.subscription': 'Subscription',
    'agency.openDashboard': 'Open dashboard',
    'agency.noClients': 'No client organizations linked yet.',
    'agency.switchContext': 'Switch to this account',
    'agency.viewingAsClient': 'You are viewing a client organization',
    'agency.returnToAgency': 'Return to agency',

    'landing.preview.reviews': 'Reviews',
    'landing.preview.avgRating': 'Avg. rating',
    'landing.preview.responseRate': 'Response rate',

    'common.comingSoon': 'Coming soon',
    'businessDetail.comingSoonPlatformsDescription': 'Additional integrations launching soon',

    'settings.profile.namePlaceholder': 'Enter your full name',
    'settings.profile.emailPlaceholder': 'Enter your email',
    'settings.password.currentPlaceholder': 'Enter your current password',
    'settings.password.newPlaceholder': 'Enter new password (min 8 characters)',
    'settings.password.confirmPlaceholder': 'Confirm your new password',

    'subscription.upgradeModalTitle': 'Plan Upgrade Required',
    'subscription.upgradeLimitReached': 'You have reached your plan limit.',
    'subscription.currentPlanLabel': 'Current plan',
    'subscription.limitTypeLabel': 'Limit type',
    'subscription.professionalPlanPrice': 'Professional Plan — 999 TRY/month',
    'subscription.upgradeProfessionalDesc': 'Direct reply posting and advanced limits.',

    'landing.howItWorks.title': 'How it works',
    'landing.howItWorks.subtitle': 'Get started in three simple steps',
    'landing.howItWorks.step1.title': 'Connect your business',
    'landing.howItWorks.step1.desc': 'Link your Google Business Profile in minutes.',
    'landing.howItWorks.step2.title': 'Sync reviews automatically',
    'landing.howItWorks.step2.desc': 'All reviews flow into one dashboard.',
    'landing.howItWorks.step3.title': 'Respond with AI insights',
    'landing.howItWorks.step3.desc': 'Analyze sentiment and reply faster.',
    'landing.pilot.title': 'Join the Pilot Program',
    'landing.pilot.subtitle': 'We are onboarding the first businesses with guided setup and rapid feedback loops.',
    'landing.pilot.cta': 'Join the first 100 businesses',
    
    'auth.forgotPassword.title': 'Reset Password',
    'auth.forgotPassword.subtitle': 'We\'ll send you a reset link',
    'auth.forgotPassword.email': 'Email',
    'auth.forgotPassword.emailPlaceholder': 'Enter your email',
    'auth.forgotPassword.send': 'Send reset link',
    'auth.forgotPassword.sending': 'Sending...',
    'auth.forgotPassword.sent': 'Email sent',
    'auth.forgotPassword.sentDesc': 'If an account exists with this email, you will receive password reset instructions.',
    'auth.forgotPassword.checkEmail': 'Check your email',
    'auth.forgotPassword.checkDesc': 'If an account exists with',
    'auth.forgotPassword.checkDesc2': 'you will receive password reset instructions.',
    'auth.forgotPassword.sendAnother': 'Send another email',
    'auth.forgotPassword.backToLogin': 'Back to login',
    'auth.forgotPassword.notFound': 'Account not found',
    'auth.forgotPassword.notFoundDesc': 'No account exists with this email address. Please check your email or register a new account.',
    'auth.forgotPassword.pending': 'Account pending',
    'auth.forgotPassword.pendingDesc': 'Your organization registration is still pending approval. Please contact your administrator or wait for approval.',
    'auth.forgotPassword.rateLimit': 'Please wait before sending another email',
    'auth.forgotPassword.rateLimitDesc': 'You can send another email in {seconds} seconds.',
    'auth.forgotPassword.error': 'Error',
    'auth.forgotPassword.errorDesc': 'An error occurred. Please try again later.',
    'auth.forgotPassword.tryAgain': 'Try again',
    
    'auth.setupPassword.title': 'Set Your Password',
    'auth.setupPassword.subtitle': 'Create a secure password for your account',
    'auth.setupPassword.email': 'Email',
    'auth.setupPassword.emailPlaceholder': 'Enter your email',
    'auth.setupPassword.password': 'New Password',
    'auth.setupPassword.passwordPlaceholder': 'Enter your new password',
    'auth.setupPassword.confirmPassword': 'Confirm Password',
    'auth.setupPassword.confirmPasswordPlaceholder': 'Confirm your password',
    'auth.setupPassword.setPassword': 'Set Password',
    'auth.setupPassword.setting': 'Setting password...',
    'auth.setupPassword.success': 'Password set successfully!',
    'auth.setupPassword.successDesc': 'Your password has been set. You can now sign in.',
    'auth.setupPassword.failed': 'Failed to set password',
    'auth.setupPassword.invalidToken': 'Invalid or expired token',
    'auth.setupPassword.invalidTokenDesc': 'The password setup link is invalid or has expired. Please request a new one.',
    'auth.setupPassword.tokenRequired': 'Token is required',
    'auth.setupPassword.tokenRequiredDesc': 'Please use the link from your email to set your password.',
    'auth.setupPassword.backToLogin': 'Back to login',
    
    // Contact
    'contact.title': 'Get in Touch',
    'contact.subtitle': 'We\'d love to hear from you. Send us a message and we\'ll respond as soon as possible.',
    'contact.form.name': 'Name',
    'contact.form.email': 'Email',
    'contact.form.phone': 'Phone',
    'contact.form.subject': 'Subject',
    'contact.form.message': 'Message',
    'contact.form.messagePlaceholder': 'Tell us more about your inquiry...',
    'contact.form.optional': 'Optional',
    'contact.form.send': 'Send Message',
    'contact.form.sending': 'Sending...',
    'contact.form.sentSuccess': 'Message Sent Successfully!',
    'contact.form.sentSuccessDesc': "We'll get back to you as soon as possible.",
    'contact.info.title': 'Contact Information',
    'contact.info.email': 'Email',
    'contact.info.emailValue': 'info@revomira.com',
    'contact.nameRequired': 'Name is required',
    'contact.emailRequired': 'Email is required',
    'contact.emailInvalid': 'Enter a valid email',
    'contact.messageRequired': 'Message is required',

    // About
    'about.title': 'About Revomira',
    'about.subtitle': 'We help businesses transform their online reputation management',
    'about.mission.title': 'Our Mission',
    'about.mission.desc': 'To empower businesses of all sizes with AI-powered tools that turn customer feedback into actionable insights, helping them build stronger relationships with their customers and grow their reputation.',
    'about.vision.title': 'Our Vision',
    'about.vision.desc': 'To become the leading platform for online reputation management, trusted by businesses worldwide to manage, analyze, and respond to customer feedback across all platforms.',
    'about.values.title': 'Our Values',
    'about.values.innovation': 'Innovation',
    'about.values.innovation.desc': 'We continuously innovate to provide cutting-edge solutions.',
    'about.values.customer': 'Customer-First',
    'about.values.customer.desc': 'Our customers\' success is our success.',
    'about.values.integrity': 'Integrity',
    'about.values.integrity.desc': 'We operate with transparency and honesty in everything we do.',
    
    // Dashboard
    'dashboard.overview': 'Overview',
    'dashboard.stats.activePlatforms': 'Active Platforms',
    'dashboard.recentReviews': 'Recent Reviews',
    'dashboard.newBusinesses': 'New Businesses',
    
    // Settings
    'settings.title': 'Settings',
    'settings.subtitle': 'Manage your account settings and preferences',
    'settings.profile.title': 'Profile Information',
    'settings.profile.subtitle': 'Update your personal information',
    'settings.profile.fullName': 'Full Name',
    'settings.profile.email': 'Email Address',
    'settings.security.title': 'Security',
    'settings.security.subtitle': 'Change your password to keep your account secure',
    'settings.security.currentPassword': 'Current Password',
    'settings.security.newPassword': 'New Password',
    'settings.security.confirmPassword': 'Confirm New Password',
    'settings.preferences.title': 'Preferences',
    'settings.preferences.subtitle': 'Customize your experience',
    'settings.preferences.theme': 'Theme',
    'settings.preferences.lightMode': 'Light mode',
    'settings.preferences.darkMode': 'Dark mode',
    'settings.preferences.language': 'Language',
    'settings.account.title': 'Account Details',
    'settings.account.subtitle': 'Your account information',
    'settings.account.role': 'Role',
    'settings.account.organization': 'Organization',
    'settings.account.status': 'Status',
    'settings.account.memberSince': 'Member since',
    'settings.managedBusinesses.title': 'Managed Businesses',
    'settings.managedBusinesses.subtitle': 'Businesses you have access to manage',
    'settings.team.title': 'Team Members',
    'settings.team.subtitle': 'Invite people to join your organization',
    'settings.team.emailPlaceholder': 'colleague@example.com',
    'settings.team.sendInvite': 'Send Invite',
    'settings.team.sending': 'Sending...',
    'settings.team.noPendingInvites': 'No pending invitations',
    'settings.team.email': 'Email',
    'settings.team.expiresAt': 'Expires',
    'settings.team.resend': 'Resend invitation',
    'settings.team.revoke': 'Revoke invitation',
    'settings.team.revokeConfirm': 'Revoke this invitation? The recipient will no longer be able to accept it.',
    'settings.team.inviteSent': 'Invitation sent',
    'settings.team.inviteSentDescription': 'An invitation email has been sent.',
    'settings.team.inviteResent': 'Invitation resent',
    'settings.team.inviteRevoked': 'Invitation revoked',
    'settings.team.inviteFailed': 'Failed to process invitation',
    'settings.team.statusPending': 'Pending',
    'settings.team.statusAccepted': 'Accepted',
    'settings.team.statusDeclined': 'Declined',
    'settings.team.statusExpired': 'Expired',
    'settings.team.statusRevoked': 'Revoked',
    'settings.digest.title': 'Digest Reports',
    'settings.digest.subtitle': 'Automated email summaries of your review activity',
    'settings.digest.enable': 'Enable digest reports',
    'settings.digest.dailyEnable': 'Daily digest',
    'settings.digest.weeklyEnable': 'Weekly digest',
    'settings.digest.sendTime': 'Send at',
    'settings.digest.sendNow': 'Send now',
    'settings.digest.recipients': 'Additional recipients',
    'settings.digest.recipientPlaceholder': 'someone@example.com',
    'settings.digest.saved': 'Digest settings saved',
    'settings.digest.saveFailed': 'Failed to save digest settings',
    'settings.digest.testSent': 'Test digest sent',
    'settings.digest.testSendFailed': 'Failed to send digest',
    'settings.digest.sunday': 'Sunday',
    'settings.digest.monday': 'Monday',
    'settings.digest.tuesday': 'Tuesday',
    'settings.digest.wednesday': 'Wednesday',
    'settings.digest.thursday': 'Thursday',
    'settings.digest.friday': 'Friday',
    'settings.digest.saturday': 'Saturday',

    // Alert thresholds
    'settings.alerts.title': 'Alert Thresholds',
    'settings.alerts.subtitle': 'Get notified when review metrics cross a threshold you set',
    'settings.alerts.name': 'Name',
    'settings.alerts.thresholdType': 'Metric',
    'settings.alerts.condition': 'Condition',
    'settings.alerts.value': 'Value',
    'settings.alerts.cooldownMinutes': 'Cooldown (minutes)',
    'settings.alerts.create': 'Create Threshold',
    'settings.alerts.update': 'Update Threshold',
    'settings.alerts.edit': 'Edit',
    'settings.alerts.delete': 'Delete',
    'settings.alerts.created': 'Alert threshold created',
    'settings.alerts.updated': 'Alert threshold updated',
    'settings.alerts.deleted': 'Alert threshold deleted',
    'settings.alerts.saveFailed': 'Failed to save alert threshold',
    'settings.alerts.deleteConfirm': 'Delete this alert threshold?',
    'settings.alerts.noThresholds': 'No alert thresholds configured yet',
    'settings.alerts.checkNow': 'Check now',
    'settings.alerts.checkComplete': 'Threshold check complete',
    'settings.alerts.checkResult': '{count} alert(s) triggered',
    'settings.alerts.activeAlerts': 'Active alerts',
    'settings.alerts.resolve': 'Resolve',
    'settings.alerts.type.ratingAverage': 'Average rating',
    'settings.alerts.type.negativeReviewCount': 'Negative review count',
    'settings.alerts.type.responseTime': 'Response time',
    'settings.alerts.type.sentimentScore': 'Sentiment score',
    'settings.alerts.type.reviewCount': 'Review count',
    'settings.alerts.type.unresolvedReviewCount': 'Unresolved review count',
    'settings.alerts.condition.below': 'is below',
    'settings.alerts.condition.above': 'is above',
    'settings.alerts.condition.equals': 'equals',

    // Response templates
    'settings.templates.title': 'Response Templates',
    'settings.templates.subtitle': 'Reusable canned replies for common review situations',
    'settings.templates.name': 'Name',
    'settings.templates.category': 'Category',
    'settings.templates.content': 'Template text',
    'settings.templates.contentPlaceholder': 'Thank you {{customerName}} for your {{rating}}-star review...',
    'settings.templates.create': 'Create Template',
    'settings.templates.update': 'Update Template',
    'settings.templates.edit': 'Edit',
    'settings.templates.delete': 'Delete',
    'settings.templates.favorite': 'Favorite',
    'settings.templates.created': 'Response template created',
    'settings.templates.updated': 'Response template updated',
    'settings.templates.deleted': 'Response template deleted',
    'settings.templates.saveFailed': 'Failed to save response template',
    'settings.templates.deleteConfirm': 'Delete this response template?',
    'settings.templates.noTemplates': 'No response templates yet',
    'settings.templates.category.positive': 'Positive',
    'settings.templates.category.negative': 'Negative',
    'settings.templates.category.neutral': 'Neutral',
    'settings.templates.category.apology': 'Apology',
    'settings.templates.category.promotional': 'Promotional',
    'settings.templates.category.general': 'General',

    'settings.saveChanges': 'Save',
    'settings.saving': 'Saving...',
    'settings.profileUpdated': 'Profile updated successfully',
    'settings.passwordChanged': 'Password changed successfully',
    'settings.passwordHint': 'Leave password fields empty if you don\'t want to change your password.',
    'settings.security.atLeast8Chars': 'At least 8 characters',
    'settings.security.containsLetterAndNumber': 'Contains letter and number',
    'settings.security.passwordStrength': 'Password strength',
    'settings.security.veryWeak': 'Very Weak',
    'settings.security.weak': 'Weak',
    'settings.security.fair': 'Fair',
    'settings.security.good': 'Good',
    'settings.security.strong': 'Strong',
    'settings.security.veryStrong': 'Very Strong',
    
    // Common
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.create': 'Create',
    'common.update': 'Update',
    'common.settings': 'Settings',
    'common.moreOptions': 'More options',
    'common.search': 'Search',
    'common.filter': 'Filter',
    'common.loading': 'Loading...',
    'common.and': 'and',
    'common.error': 'Error',
    'common.errorDescription': 'An error occurred while loading data. Please try again.',
    'common.tryAgain': 'Try Again',
    'common.success': 'Success',
    'common.noData': 'No data available',
    'common.user': 'User',
    'common.all': 'All',
    'common.created': 'Created',
    'common.export': 'Export',
    'common.refresh': 'Refresh',
    'common.sync': 'Sync',
    'common.showing': 'Showing',
    'common.of': 'of',
    'common.page': 'Page',
    'common.status': 'Status',
    'common.add': 'Add',
    'common.remove': 'Remove',
    'common.info': 'Info',
    'common.active': 'Active',
    'common.inactive': 'Inactive',
    'common.close': 'Close',
    'common.copy': 'Copy',
    'common.logout': 'Logout',
    'common.name': 'Name',
    'common.na': 'N/A',
    'common.validationError': 'Validation Error',
    'common.validationErrorDescription': 'Please fix the form errors',
    'validation.required': 'Please fill out this field',
    'validation.minLength': 'Minimum length is {min}',
    'validation.maxLength': 'Maximum length is {max}',
    'validation.invalidFormat': 'Invalid format',
    'auth.logout': 'Logout',
    'auth.showPassword': 'Show password',
    'auth.hidePassword': 'Hide password',
    'auth.register.password': 'Password',
    'auth.register.passwordPlaceholder': 'At least 8 characters',
    'auth.register.passwordMinLength': 'Password must be at least 8 characters',
    'platform.comingSoon': 'Coming soon',
    'error.boundary.title': 'Something went wrong',
    'error.boundary.description': 'An unexpected error occurred. Please try again.',
    'error.boundary.retry': 'Try again',
    'topbar.toggleSidebar': 'Toggle sidebar',
    'topbar.toggleCollapse': 'Toggle sidebar collapse',
    'topbar.languageMenu': 'Language menu',
    'topbar.themeToggle': 'Toggle theme',
    'topbar.userMenu': 'User menu',
    'validation.email': 'Please enter a valid email address',
    'validation.emailInvalid': 'Please enter a valid email address',
    'validation.password': 'Please enter a password',
    'validation.passwordMinLength': 'Password must be at least 8 characters long',
    'validation.passwordFormat': 'Password must contain at least one letter and one number',
    'validation.passwordsDoNotMatch': 'Passwords do not match',
    'validation.passwordsMatch': 'Passwords match',
    'validation.currentPasswordRequired': 'Current password is required to change password',
    'common.pending': 'Pending',
    'common.previous': 'Previous',
    'common.next': 'Next',
    'common.total': 'total',
    
    // Dashboard Page
    'dashboard.title': 'Dashboard',
    'dashboard.welcome': 'Welcome back',
    'dashboard.stats.description': 'Overview of your business performance',
    'dashboard.stats.totalBusinesses': 'Total Businesses',
    'dashboard.stats.totalReviews': 'Total Reviews',
    'dashboard.stats.averageRating': 'Average Rating',
    'dashboard.stats.positiveRatio': 'Positive Ratio',
    'dashboard.stats.connectedPlatforms': 'Connected Platforms',
    'dashboard.stats.activeSubscriptions': 'Active Subscriptions',
    'dashboard.stats.vsLastMonth': 'vs last month',
    'dashboard.stats.outOf5': 'out of 5.0',
    'dashboard.stats.positiveReviews': 'positive reviews',
    'dashboard.stats.activeIntegrations': 'active integrations',
    'dashboard.stats.currentPlans': 'current plans',
    'dashboard.stats.totalLocations': 'total locations',
    'dashboard.recentReviews.title': 'Recent Reviews',
    'dashboard.recentReviews.description': 'Latest customer feedback across all platforms',
    'dashboard.recentReviews.empty': 'No reviews yet',
    'dashboard.recentReviews.emptyDescription': 'Reviews will appear here once customers start leaving feedback.',
    'dashboard.newBusinesses.title': 'New Businesses',
    'dashboard.newBusinesses.description': 'Your business locations',
    'dashboard.newBusinesses.added': 'Added',
    'dashboard.newBusinesses.connectedPlatforms': 'Connected Platforms',
    'dashboard.newBusinesses.empty': 'No businesses yet',
    'dashboard.newBusinesses.emptyDescription': 'Add your first business location to start managing reviews.',
    'dashboard.viewAll': 'View All',
    
    // System Admin Dashboard
    'dashboard.systemAdmin.title': 'System Administration',
    'dashboard.systemAdmin.welcome': 'Welcome to the system administration dashboard',
    'dashboard.systemAdmin.manageOrganizations': 'Manage all organizations',
    'dashboard.systemAdmin.manageUsers': 'View and manage users',
    'dashboard.systemAdmin.pendingApprovals': 'Pending approvals',
    'dashboard.systemAdmin.systemSettings': 'System settings',
    'dashboard.systemAdmin.allOrganizations': 'All registered organizations',
    'dashboard.systemAdmin.activeOrganizations': 'Approved and active',
    'dashboard.systemAdmin.awaitingApproval': 'Awaiting approval',
    'dashboard.systemAdmin.allUsers': 'All system users',
    'dashboard.systemAdmin.pendingRegistrations': 'Pending Organization Registrations',
    'dashboard.systemAdmin.pendingRegistrationsDescription': 'You have {count} organization registration(s) awaiting approval.',
    'dashboard.systemAdmin.reviewPending': 'Review Pending Registrations',
    'dashboard.systemAdmin.quickActions': 'Quick Actions',
    'dashboard.systemAdmin.quickActionsDescription': 'Common administrative tasks',
    'dashboard.systemAdmin.systemOverview': 'System Overview',
    'dashboard.systemAdmin.systemOverviewDescription': 'Current system status and statistics',
    'common.view': 'View',
    'common.viewDetails': 'View Details',
    'common.readOnly': 'Read-only',
    'common.details': 'Details',
    'common.createdAt': 'Created At',
    'common.updatedAt': 'Updated At',
    
    // Business Page
    'business.title': 'Businesses',
    'business.subtitle': 'Manage your businesses',
    'business.create': 'Create Business',
    'business.name': 'Business Name',
    'business.description': 'Description',
    'business.address': 'Address',
    'business.phone': 'Phone',
    'business.phoneNumber': 'Phone Number',
    'business.email': 'Email',
    'business.businessType': 'Business Type',
    'business.website': 'Website',
    'business.status': 'Status',
    'business.active': 'Active',
    'business.inactive': 'Inactive',
    'business.actions': 'Actions',
    'business.edit': 'Edit',
    'business.delete': 'Delete',
    'business.noBusinesses': 'No businesses found',
    'business.createNew': 'Create your first business',
    'business.activate': 'Activate',
    'business.deactivate': 'Deactivate',
    'business.outOf': 'out of',
    'business.acrossAll': 'across all businesses',
    'business.averageAcross': 'average across businesses',
    'business.type': 'Business Type',
    'business.typeRestaurant': 'Restaurant',
    'business.typeHotel': 'Hotel',
    'business.typeRetail': 'Retail',
    'business.typeHealthcare': 'Healthcare',
    'business.typeTechnology': 'Technology',
    'business.typeEducation': 'Education',
    'business.typeFinance': 'Finance',
    'business.typeOther': 'Other',
    'business.created': 'Business created',
    'business.createdDescription': 'Business has been created successfully.',
    'business.createFailed': 'Failed to create business.',
    'business.notFound': 'Organization ID or business not found',
    'business.updatedDescription': 'Business updated successfully',
    'business.updateFailed': 'Failed to update business',
    'business.activated': 'Business activated',
    'business.activatedDescription': 'Business has been activated successfully.',
    'business.deactivated': 'Business deactivated',
    'business.deactivatedDescription': 'Business has been deactivated successfully.',
    'business.statusUpdateFailed': 'Failed to update business status',
    'business.deleted': 'Business deleted',
    'business.deletedDescription': 'Business has been deleted successfully.',
    'business.deleteFailed': 'Failed to delete business.',
    'business.organizationIdNotFound': 'Organization ID not found',
    'business.activateConfirm': 'Are you sure you want to activate this business?',
    'business.deactivateConfirm': 'Are you sure you want to deactivate this business?',
    'business.deleteConfirm': 'Are you sure you want to delete this business? This action cannot be undone.',
    
    // Review Page
    'review.title': 'Reviews',
    'review.subtitle': 'Manage and respond to customer reviews',
    'review.selectAll': 'Select all',
    'review.filter': 'Filter',
    'review.search': 'Search reviews',
    'review.platform': 'Platform',
    'review.rating': 'Rating',
    'review.date': 'Date',
    'review.customer': 'Customer',
    'review.comment': 'Comment',
    'review.response': 'Response',
    'review.respond': 'Respond',
    'review.noReviews': 'No reviews found',
    'review.aiAnalysis': 'AI Analysis',
    'review.analysis': 'AI Analyses',
    'review.sentiment': 'Sentiment',
    'review.positive': 'Positive',
    'review.neutral': 'Neutral',
    'review.negative': 'Negative',
    'review.analyzed': 'Analyzed',
    'review.thisMonth': 'This Month',
    'review.sortBy': 'Sort By',
    'review.newestFirst': 'Newest First',
    'review.oldestFirst': 'Oldest First',
    'review.highestRating': 'Highest Rating',
    'review.lowestRating': 'Lowest Rating',
    'review.platformAZ': 'Platform A-Z',
    'review.analyzeSelected': 'Analyze Selected',
    'review.analyzePending': 'Analyze pending reviews',
    'review.analysisUpToDate': 'All reviews already analyzed',
    'review.analyze': 'Analyze',
    'review.analyzing': 'Analyzing...',
    'review.aiAnalysisInProgress': 'AI is analyzing this review. This may take a few moments...',
    'review.pleaseWait': 'Please wait while we analyze this review',
    'review.analysisComplete': 'Analysis Complete!',
    'review.analysisSuccess': 'Review has been successfully analyzed',
    'review.analysisCompleted': 'AI Analysis Complete',
    'review.analysisCompletedDescription': 'reviews have been successfully analyzed.',
    'review.analysisSingleCompleted': 'Review analyzed',
    'review.analysisSingleCompletedDescription': 'AI insights added to this review.',
    'review.analysisStarted': 'Analysis started',
    'review.analysisStartedDescription': 'AI analysis started for {count} reviews.',
    'review.exportStarted': 'Export started',
    'review.exportStartedDescription': 'Review export has been started.',
    'review.loadFailed': 'Failed to load reviews',
    'review.star': 'Star',
    'review.stars': 'Stars',
    'review.syncReviews': 'Sync Reviews',
    'review.syncing': 'Syncing...',
    'review.syncSuccess': 'Reviews synced successfully',
    'review.syncFailed': 'Failed to sync reviews',
    'review.reviewsSynced': 'reviews synced',
    'review.noPlatformsConnected': 'No platforms connected. Please connect a platform first.',
    'review.lastSynced': 'Last synced',
    'review.never': 'Never',
    'review.syncOnePlatform': 'Sync 1 Platform',
    'review.syncMultiplePlatforms': 'Sync {count} Platforms',
    'review.noBusinessSelected': 'Please select a business first',
    'review.selectOrganizationPrompt': 'Please select an organization to view reviews',
    'review.showing': 'Showing {start} to {end} of {total} reviews',
    'review.chooseAnalysisType': 'Choose analysis type',
    'review.analyzeAll': 'Analyze All Reviews',
    'review.analysisFailed': 'Failed to analyze reviews',
    'review.anonymous': 'Anonymous',
    'review.averageRating': 'Average Rating',
    'review.backToReviews': 'Back to Reviews',
    'review.details': 'Review Details',
    'review.reviewText': 'Review Text',
    'review.aiAnalysisDescription': 'AI-powered sentiment and topic analysis',
    'review.topics': 'Topics',
    'review.summary': 'Summary',
    'review.responseSuggestions': 'Response Suggestions',
    'review.reply.description': 'Send a direct reply for this Google review.',
    'review.reply.placeholder': 'Write your reply...',
    'review.reply.alreadyResponded': 'This review has already been replied to.',
    'review.reply.repliedViaRevomira': 'Replied via Revomira',
    'review.reply.repliedOnGoogle': 'Replied on Google',
    'review.reply.update': 'Update Reply',
    'review.reply.replaceTitle': 'Replace existing reply?',
    'review.reply.replaceWarning': 'This review already has a reply. Sending a new one will replace the current reply on the platform. Do you want to continue?',
    'review.reply.replaceConfirm': 'Replace reply',
    'review.reply.successTitle': 'Success',
    'review.reply.successDesc': 'Reply sent to the platform.',
    'review.reply.failedDesc': 'Reply could not be sent.',
    'review.reply.sending': 'Sending...',
    'review.reply.send': 'Send Reply',
    'review.reply.chooseTemplate': 'Choose a template...',
    'review.reply.applyTemplate': 'Use template',
    'review.reply.templateApplyFailed': 'Failed to apply template',
    'review.reply.generateAi': 'Generate AI response',
    'review.reply.aiGenerating': 'Generating...',
    'review.reply.aiGenerateFailed': 'Failed to generate an AI response',
    'review.confidence': 'confidence',
    
    // AI Analysis - Sentiments
    'sentiment.positive': 'Positive',
    'sentiment.negative': 'Negative',
    'sentiment.neutral': 'Neutral',
    'sentiment.mixed': 'Mixed',
    
    // AI Analysis - Topics
    'topic.service': 'Service',
    'topic.quality': 'Quality',
    'topic.staff': 'Staff',
    'topic.atmosphere': 'Atmosphere',
    'topic.price': 'Price',
    'topic.location': 'Location',
    'topic.cleanliness': 'Cleanliness',
    'topic.food': 'Food',
    'topic.value': 'Value',
    'topic.amenities': 'Amenities',
    'topic.overall_experience': 'Overall Experience',
    'topic.accommodation': 'Accommodation',
    
    // AI Analysis - Suggestion Categories
    'suggestionCategory.response': 'Response',
    'suggestionCategory.improvement': 'Improvement',
    'suggestionCategory.action': 'Action',
    
    // AI Analysis - Priorities
    'priority.high': 'High',
    'priority.medium': 'Medium',
    'priority.low': 'Low',
    
    // AI Analysis - Tones
    'tone.apologetic': 'Apologetic',
    'tone.grateful': 'Grateful',
    'tone.neutral': 'Neutral',
    'tone.professional': 'Professional',
    'review.platformRawData': 'Platform Raw Data',
    'review.originalReviewData': 'Original review data from',
    'review.downloadRawData': 'Download Raw Data (JSON)',
    'review.metadata': 'Metadata',
    'review.reviewId': 'Review ID',
    'review.platformReviewId': 'Platform Review ID',
    'review.syncedAt': 'Synced At',
    'review.updatedAt': 'Updated At',
    'review.analysisResultId': 'Analysis Result ID',
    'common.actions': 'Actions',
    'review.analyzeWithAI': 'Analyze with AI',
    'review.analysisQueued': 'AI analysis has been queued for this review',
    'review.viewAllReviews': 'View All Reviews',
    'review.notFound': 'Review not found',
    
    // Organization Page
    'organization.title': 'Organizations',
    'organization.subtitle': 'Manage organizations',
    'organization.create': 'Create Organization',
    'organization.name': 'Organization Name',
    'organization.contactEmail': 'Contact Email',
    'organization.contactName': 'Contact Name',
    'organization.phoneNumber': 'Phone Number',
    'organization.website': 'Website',
    'organization.phoneNumberHint': 'Use international format (e.g., +905558883322)',
    'organization.status': 'Status',
    'organization.pending': 'Pending',
    'organization.active': 'Active',
    'organization.inactive': 'Inactive',
    'organization.users': 'Users',
    'organization.businesses': 'Businesses',
    'organization.edit': 'Edit',
    'organization.delete': 'Delete',
    'organization.manage': 'Manage Organizations',
    'organization.manageUsers': 'Manage Users',
    'organization.noOrganizations': 'No organizations found',
    'organization.noUsers': 'No users found',
    'organization.stats.total': 'Total Organizations',
    'organization.stats.totalUsers': 'Total Users',
    'organization.allUsers': 'All Users',
    'organization.allUsersDescription': 'Manage every user across all organizations from a single view.',
    'organization.admin': 'Organization Admin',
    'organization.user': 'Organization User',
    'organization.userRemoveConfirm': 'Are you sure you want to remove this user',
    'organization.userRemoved': 'User removed',
    'organization.userRemovedDescription': 'User has been removed successfully.',
    'organization.userRemoveFailed': 'Failed to remove user.',
    'organization.approve': 'Approve',
    'organization.approveConfirm': 'Are you sure you want to approve this organization? This action cannot be undone.',
    'organization.reject': 'Reject',
    'organization.created': 'Organization created',
    'organization.createdDescription': 'Organization has been created successfully.',
    'organization.createFailed': 'Failed to create organization.',
    'organization.updated': 'Organization updated',
    'organization.updatedDescription': 'Organization has been updated successfully.',
    'organization.updateFailed': 'Failed to update organization.',
    'organization.deleteConfirm': 'Are you sure you want to delete',
    'organization.deleted': 'Organization deleted',
    'organization.deletedDescription': 'Organization has been deleted successfully.',
    'organization.deleteFailed': 'Failed to delete organization.',
    'organization.role': 'Role',
    'organization.approved': 'Organization approved',
    'organization.approvedDescription': 'Organization has been approved successfully.',
    'organization.approveFailed': 'Failed to approve organization.',
    'organization.rejected': 'Organization rejected',
    'organization.rejectedDescription': 'Organization has been rejected.',
    'organization.rejectFailed': 'Failed to reject organization.',
    'organization.status.approved': 'Approved',
    'organization.status.pending': 'Pending',
    'organization.status.rejected': 'Rejected',
    'organization.status.active': 'Active',
    'organization.status.inactive': 'Inactive',
    'organization.pendingRequests': 'Pending registrations',
    'organization.pendingHelp': 'Review incoming organization requests and approve them to grant access.',
    'organization.requestedOn': 'Requested on',
    'organization.contact': 'Contact',
    'organization.noPending': 'There are no pending registrations right now.',
    'organization.selectOrganization': 'Select organization',
    'organization.selectOrganizationHelp': 'Choose an organization to manage its businesses and reviews.',
    'organization.noOrganizationAvailable': 'No organizations available yet. Approve a pending request first.',
    'business.selectBusiness': 'Select business',
    'business.selectBusinessHelp': 'Choose which business data to view.',
    'business.noBusinessAvailable': 'This organization has no businesses yet.',
    
    // Subscription Page
    'subscription.title': 'Subscription',
    'subscription.subtitle': 'Manage your subscription plan',
    'subscription.currentPlan': 'Current Plan',
    'subscription.upgrade': 'Upgrade',
    'subscription.downgrade': 'Downgrade',
    'subscription.cancel': 'Cancel Subscription',
    'subscription.renew': 'Renew',
    'subscription.active': 'Active',
    'subscription.cancelled': 'Cancelled',
    'subscription.trial': 'Trial',
    'subscription.inactive': 'Inactive',
    'subscription.expired': 'Expired',
    'subscription.planBasic': 'Basic Plan',
    'subscription.planProfessional': 'Professional Plan',
    'subscription.planEnterprise': 'Enterprise Plan',
    'subscription.nextBilling': 'Next Billing Date',
    'subscription.noSubscription': 'No active subscription',
    'subscription.upgradePlan': 'Upgrade Plan',
    'subscription.monthly': 'Monthly',
    'subscription.yearly': 'Yearly',
    'subscription.billing': 'billing',
    'subscription.per': 'per',
    'subscription.month': 'month',
    'subscription.year': 'year',
    'subscription.planFeatures': 'Plan Features',
    'subscription.usageLimits': 'Usage Limits',
    'subscription.billingInfo': 'Billing Info',
    'subscription.started': 'Started',
    'subscription.updatePaymentMethod': 'Update Payment Method',
    'subscription.noActiveSubscription': 'No Active Subscription',
    'subscription.noActiveSubscriptionDescription': 'You don\'t have an active subscription. Choose a plan to get started.',
    'subscription.choosePlan': 'Choose a Plan',
    'subscription.noSubscriptions': 'No subscriptions found',
    'subscription.nearLimit': 'You are near your plan limit.',
    'subscription.limitReached': 'Plan limit reached.',
    'subscription.history': 'Subscription History',
    'subscription.historyDescription': 'Your subscription changes and billing history',
    'subscription.usage': 'Usage Summary',
    'subscription.plan': 'Plan',
    'subscription.billingCycle': 'Billing Cycle',
    'subscription.price': 'Price',
    'subscription.startDate': 'Start Date',
    'subscription.endDate': 'End Date',
    'subscription.trialEndDate': 'Trial End Date',
    'subscription.reactivate': 'Reactivate',
    'subscription.billingHistory': 'Billing History',
    'subscription.upgraded': 'Subscription upgraded',
    'subscription.upgradedDescription': 'Your subscription has been upgraded successfully.',
    'subscription.cancelledToast': 'Subscription cancelled',
    'subscription.cancelledDescription': 'Your subscription has been cancelled. You can continue using the service until the end of your billing period.',
    'subscription.reactivated': 'Subscription reactivated',
    'subscription.reactivatedDescription': 'Your subscription has been reactivated successfully.',
    'subscription.cancelConfirm': 'Are you sure you want to cancel your subscription?',
    'subscription.cancelConfirmDescription': 'You can continue using the service until the end of your billing period.',
    'subscription.keepSubscription': 'Keep Subscription',
    'subscription.upgradeFailed': 'Failed to upgrade subscription.',
    'subscription.cancelFailed': 'Failed to cancel subscription.',
    'subscription.reactivateFailed': 'Failed to reactivate subscription.',
    'subscription.downloadInvoiceFailed': 'Failed to download invoice.',
    'subscription.upgradeTo': 'Upgrade to',
    'subscription.description': 'Description',
    'subscription.amount': 'Amount',
    'subscription.invoiceDownloaded': 'Invoice downloaded',
    'subscription.invoiceDownloadedDescription': 'Invoice has been downloaded successfully.',
    'subscription.paid': 'Paid',
    'subscription.failed': 'Failed',
    'subscription.loadFailed': 'Failed to load subscription data',
    
    // Charts
    'charts.reviewSentiment': 'Review Sentiment',
    'charts.sentimentDescription': 'Distribution of positive, neutral, and negative reviews',
    'charts.reviewsOverTime': 'Reviews Over Time',
    'charts.reviewsOverTimeDescription': 'Review trends for the last 30 days',
    'charts.businessPerformance': 'Business Performance',
    'charts.businessPerformanceDescription': 'Business performance metrics',
    'charts.noBusinessData': 'No business data available',
    'charts.addBusinesses': 'Add businesses to see performance metrics',
    'charts.platformActivity': 'Platform Activity',
    'charts.platformActivityDescription': 'Review distribution across platforms',
    'charts.noPlatformData': 'No platform data available',
    'charts.connectPlatforms': 'Connect platforms to see activity',
    'charts.percentage': 'Percentage',
    
    // Analytics
    'analytics.advancedAnalytics': 'Advanced Analytics',
    'analytics.advancedAnalyticsDescription': 'Trend analysis, insights, and topic detection',
    'analytics.sentimentTrend': 'Sentiment Trend',
    'analytics.sentimentTrendDescription': 'Sentiment analysis over time',
    'analytics.sentimentChange': 'sentiment change',
    'analytics.sentiment': 'Sentiment',
    'analytics.insights': 'Actionable Insights',
    'analytics.insightsDescription': 'Important trends and recommendations',
    'analytics.noInsights': 'No insights available yet. Analyze reviews to generate insights.',
    'analytics.suggestion': 'Suggestion',
    'analytics.topKeywords': 'Top Keywords',
    'analytics.topKeywordsDescription': 'Most mentioned keywords in reviews',
    'analytics.noKeywords': 'No keywords available yet. Analyze reviews to extract keywords.',
    'analytics.topics': 'Topic Analysis',
    'analytics.topicsDescription': 'Most mentioned topics and problem areas',
    'analytics.noTopics': 'No topics available yet. Analyze reviews to detect topics.',
    'analytics.problemAreas': 'Problem Areas',
    'analytics.positiveTopics': 'Positive Topics',
    'analytics.mentionedIn': 'Mentioned in',
    'analytics.topicMentions': 'Topic Mentions',
    'analytics.mentions': 'Mentions',
    'analytics.noTrendData': 'No trend data available',
    'analytics.analyzeReviews': 'Analyze reviews to see trends',
    'analytics.noBusinessSelected': 'Select a business to view analytics',
    'analytics.selectBusiness': 'Business for analytics',
    'common.count': 'Count',
    'common.days': 'Days',
    'common.high': 'High',
    'common.medium': 'Medium',
    'common.low': 'Low',
    
    // Business Detail Page
    'businessDetail.loadFailed': 'Failed to load business data',
    'businessDetail.notFound': 'Business Not Found',
    'businessDetail.notFoundDescription': 'The business you\'re looking for doesn\'t exist or you don\'t have access to it.',
    'businessDetail.backToBusinesses': 'Back to Businesses',
    'businessDetail.connectPlatform': 'Connect Platform',
    'businessDetail.fromBusinessData': 'from business data',
    'businessDetail.connectedPlatforms': 'Connected Platforms',
    'businessDetail.connectedPlatformsDescription': 'Manage your platform integrations and review sources',
    'businessDetail.connected': 'Connected',
    'businessDetail.recently': 'Recently',
    'businessDetail.sync': 'Sync',
    'businessDetail.every': 'Every',
    'businessDetail.hours': 'hours',
    'businessDetail.lastSync': 'Last sync',
    'businessDetail.never': 'Never',
    'businessDetail.disconnect': 'Disconnect',
    'businessDetail.noPlatforms': 'No platforms connected yet',
    'businessDetail.noPlatformsDescription': 'Click "Connect Platform" to add your first platform integration',
    'businessDetail.recentReviews': 'Recent Reviews',
    'businessDetail.recentReviewsDescription': 'Latest customer feedback and AI analysis',
    'businessDetail.viewDetails': 'View Details',
    'businessDetail.connectNewPlatform': 'Connect New Platform',
    'businessDetail.businessSettings': 'Business Settings',
    'businessDetail.missingAuthCode': 'Missing Authorization Code',
    'businessDetail.missingAuthCodeDescription': 'Please provide a valid authorization code from the platform.',
    'businessDetail.platformConnected': 'Platform connected',
    'businessDetail.platformConnectedDescription': 'has been connected successfully.',
    'businessDetail.connectFailed': 'Failed to connect platform.',
    'businessDetail.analysisStartedDescription': 'AI analysis is running in the background.',
    'businessDetail.settingsSaved': 'Settings saved',
    'businessDetail.settingsSavedDescription': 'Business settings have been updated successfully.',
    'businessDetail.settingsSaveFailed': 'Failed to save business settings.',
    'businessDetail.platformSettingsSaved': 'Platform settings saved',
    'businessDetail.platformSettingsSavedDescription': 'settings have been updated successfully.',
    'businessDetail.platformSettingsSaveFailed': 'Failed to save platform settings.',
    'businessDetail.disconnectConfirm': 'Are you sure you want to disconnect',
    'businessDetail.disconnectConfirmDescription': 'This will stop syncing reviews from this platform.',
    'businessDetail.platformDisconnected': 'Platform disconnected',
    'businessDetail.platformDisconnectedDescription': 'has been disconnected successfully.',
    'businessDetail.disconnectFailed': 'Failed to disconnect platform.',
    'businessDetail.selectPlatform': 'Select a platform',
    'businessDetail.authorizationCode': 'Authorization Code',
    'businessDetail.authorizationCodePlaceholder': 'Enter authorization code from platform',
    'businessDetail.authorizationCodeHint': 'Get this code from the platform\'s OAuth flow',
    'businessDetail.redirectUri': 'Redirect URI',
    'businessDetail.redirectUriHint': 'The redirect URI used in the OAuth flow',
    'businessDetail.oauthSupported': 'This platform supports OAuth authentication. Click the button below to connect automatically.',
    'businessDetail.connectWithOAuth': 'Connect with OAuth',
    'businessDetail.selectPlatformFirst': 'Please select a platform first',
    'businessDetail.popupBlocked': 'Popup was blocked. Please allow popups for this site and try again.',
    'businessDetail.oauthCancelled': 'OAuth authorization was cancelled',
    'businessDetail.oauthFailed': 'OAuth authorization failed',
    'businessDetail.notificationEmail': 'Notification Email',
    'businessDetail.enableAiAnalysis': 'Enable AI Analysis',
    'businessDetail.enableAutoResponse': 'Enable Auto Response',
    'businessDetail.syncFrequency': 'Sync Frequency (Hours)',
    'businessDetail.responseTemplate': 'Response Template',
    'businessDetail.responseTemplatePlaceholder': 'Enter your response template...',
    'businessDetail.every6Hours': 'Every 6 Hours',
    'businessDetail.every12Hours': 'Every 12 Hours',
    'businessDetail.daily24Hours': 'Daily (24 Hours)',
    'businessDetail.syncFrequencyHint': 'How often to sync reviews from this platform',
    'businessDetail.googleLocationNotConnected': 'Google My Business location not connected',
    'businessDetail.connectBusiness': 'Connect Business',
    'businessDetail.googleLocationConnected': 'Location connected',
    'businessDetail.selectGoogleLocation': 'Select Google My Business Location',
    'businessDetail.googleLocationSelected': 'Google My Business location connected successfully',
    'businessDetail.failedToFetchGoogleAccounts': 'Failed to fetch Google accounts and locations',
    'businessDetail.noGoogleAccountsFound': 'No Google My Business accounts found',
    'businessDetail.accessToken': 'Access Token',
    'businessDetail.accessTokenPlaceholder': 'Enter new access token (optional)',
    'businessDetail.accessTokenHint': 'Leave empty to keep current token',
    'businessDetail.refreshToken': 'Refresh Token',
    'businessDetail.refreshTokenPlaceholder': 'Enter new refresh token (optional)',
    'businessDetail.refreshTokenHint': 'Leave empty to keep current token',
    'businessDetail.savePlatformSettings': 'Save Platform Settings',
    'businessDetail.unknownBusiness': 'Unknown Business',
    'businessDetail.noDescription': 'No description available',
    'businessDetail.viewAllReviews': 'View All Reviews',
    'businessDetail.noReviews': 'No reviews available',
    'businessDetail.reconnectPlatform': 'Reconnect Platform',
    'businessDetail.selectGoogleAccount': 'Select Google Account',
    'businessDetail.selectAccount': 'Select an account',
    'businessDetail.selectLocation': 'Select a location',
    'businessDetail.noLocationsFound': 'No locations found for this account',
    'businessDetail.selectAndConnect': 'Select and Connect',
    'businessDetail.locationSelectionFailed': 'Failed to select location',
    'platform.connectionExpiredTitle': 'Platform Connection Expired',
    'platform.connectionExpiredDescription': 'Please reconnect the platform to continue syncing reviews.',
    'platform.connectionIssue.accessExpired': 'Access token expired',
    'platform.connectionIssue.refreshMissing': 'Refresh token missing or invalid',
    'platform.locationNotFoundTitle': 'Business Location Not Found',
    'platform.locationNotFoundDescription': 'The business location could not be found on Google My Business. Please verify that the business is properly set up on Google My Business and try again.',
    'review.noComment': 'No comment available',
    'invitations.pageTitle': 'Accept Invitation',
    'invitations.title': 'Team Invitation',
    'invitations.description': 'You have been invited to join an organization on Revomira.',
    'invitations.checking': 'Checking invitation...',
    'invitations.needsLoginDescription': 'Log in or create an account to accept this invitation.',
    'invitations.logInToContinue': 'Log In to Continue',
    'invitations.accept': 'Accept',
    'invitations.decline': 'Decline',
    'invitations.acceptedTitle': 'Invitation Accepted',
    'invitations.acceptedDescription': 'You have joined the organization.',
    'invitations.declinedTitle': 'Invitation Declined',
    'invitations.goToDashboard': 'Go to Dashboard',
    'invitations.backToHome': 'Back to Home',
    'invitations.missingToken': 'This invitation link is missing its token.',
    'invitations.acceptFailed': 'Invalid or expired invitation.',
    'invitations.declineFailed': 'Invalid or expired invitation.',
};
